import { render, staticRenderFns } from "./TariffPetsItem.vue?vue&type=template&id=0a9a3abc&scoped=true&"
import script from "./TariffPetsItem.vue?vue&type=script&lang=ts&"
export * from "./TariffPetsItem.vue?vue&type=script&lang=ts&"
import style0 from "./TariffPetsItem.vue?vue&type=style&index=0&id=0a9a3abc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9a3abc",
  null
  
)

export default component.exports